// Every provider is called through its OpenAI compatible chat completions API.
// Keep the keys, default URLs and default models in sync with PROVIDER_DEFAULTS in the backend llmutils.py.
export const LLM_PROVIDERS = [
  {
    key: "openai",
    label: "OpenAI",
    defaultBaseUrl: "https://api.openai.com/v1",
    keyRequired: true,
    defaultModel: "gpt-4.1-mini",
    modelSuggestions: ["gpt-4.1", "gpt-4.1-mini", "gpt-4o", "gpt-4o-mini"],
  },
  {
    key: "azure",
    label: "Azure OpenAI",
    defaultBaseUrl: "",
    baseUrlPlaceholder: "https://<resource-name>.openai.azure.com",
    keyRequired: true,
    defaultModel: "",
    modelSuggestions: [],
  },
  {
    key: "anthropic",
    label: "Anthropic Claude",
    defaultBaseUrl: "https://api.anthropic.com/v1",
    keyRequired: true,
    defaultModel: "claude-sonnet-5-5",
    modelSuggestions: ["claude-sonnet-5-5", "claude-opus-5-5", "claude-haiku-5-5"],
  },
  {
    key: "gemini",
    label: "Google Gemini",
    defaultBaseUrl: "https://generativelanguage.googleapis.com/v1beta/openai",
    keyRequired: true,
    defaultModel: "gemini-2.5-flash",
    modelSuggestions: ["gemini-2.5-pro", "gemini-2.5-flash"],
  },
  {
    key: "mistral",
    label: "Mistral AI",
    defaultBaseUrl: "https://api.mistral.ai/v1",
    keyRequired: true,
    defaultModel: "mistral-small-latest",
    modelSuggestions: ["mistral-large-latest", "mistral-small-latest"],
  },
  {
    key: "groq",
    label: "Groq",
    defaultBaseUrl: "https://api.groq.com/openai/v1",
    keyRequired: true,
    defaultModel: "llama-3.3-70b-versatile",
    modelSuggestions: ["llama-3.3-70b-versatile", "llama-3.1-8b-instant"],
  },
  {
    key: "deepseek",
    label: "DeepSeek",
    defaultBaseUrl: "https://api.deepseek.com/v1",
    keyRequired: true,
    defaultModel: "deepseek-chat",
    modelSuggestions: ["deepseek-chat", "deepseek-reasoner"],
  },
  {
    key: "openrouter",
    label: "OpenRouter",
    defaultBaseUrl: "https://openrouter.ai/api/v1",
    keyRequired: true,
    defaultModel: "",
    modelSuggestions: [
      "openai/gpt-4o",
      "anthropic/claude-sonnet-4.5",
      "meta-llama/llama-3.3-70b-instruct",
    ],
  },
  {
    key: "ollama",
    label: "Ollama (Self-hosted)",
    defaultBaseUrl: "http://localhost:11434/v1",
    keyRequired: false,
    defaultModel: "llama3.1",
    modelSuggestions: ["llama3.1", "qwen2.5", "mistral"],
  },
  {
    key: "custom",
    label: "Custom (OpenAI Compatible)",
    defaultBaseUrl: "",
    baseUrlPlaceholder: "https://llm.company.local/v1/chat/completions",
    keyRequired: false,
    defaultModel: "",
    modelSuggestions: [],
  },
];

export const DEFAULT_AZURE_API_VERSION = "2024-10-21";

export const getProvider = (key) => LLM_PROVIDERS.find((p) => p.key === key) || LLM_PROVIDERS[0];
